

const hexToHsl = require('../hex/toHsl');
const cycleLum = require('../internal/cycleLum');
const cycleSat = require('../internal/cycleSat');
const cycleHue = require('../internal/cycleHue');

module.exports = (seed, number, mode) => {
  let colors = [];
  let hsl = hexToHsl(seed);
  if (!hsl.sat || mode === 'lum') {
    colors = cycleLum(hsl, number);
  } else if (mode === 'sat') {
    colors = cycleSat(hsl, number);
  } else if (mode === 'hue') {
    colors = cycleHue(hsl, number);
  }
  colors.unshift(seed.toUpperCase());
  return colors;
};


// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/generate.js